var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVillage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8766_290502)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5627 6.66592C19.8445 6.11347 18.8515 6.08857 18.1066 6.60432L15.8481 8.16785L13.9369 6.69766C13.188 6.12161 12.1453 6.12161 11.3964 6.69766L4.0631 12.3387C3.55043 12.7331 3.25 13.3432 3.25 13.99V25.0668C3.25 25.6283 3.70518 26.0834 4.26667 26.0834H9.73333C10.2948 26.0834 10.75 25.6283 10.75 25.0668V18.7501H14.5833V25.0668C14.5833 25.6283 15.0385 26.0834 15.6 26.0834H21.0667C21.6282 26.0834 22.0833 25.6283 22.0833 25.0668V13.99C22.0833 13.3432 21.7829 12.7331 21.2702 12.3387L17.0964 9.12805L18.9604 7.83761C19.169 7.6932 19.447 7.70017 19.6481 7.85486L27.0228 13.5277C27.1664 13.6381 27.2505 13.809 27.2505 13.9901V24.5836H24.0005V26.0836H27.7338C28.2953 26.0836 28.7505 25.6284 28.7505 25.0669V13.9901C28.7505 13.3433 28.4501 12.7332 27.9374 12.3388L20.5627 6.66592ZM12.311 7.88659C12.5207 7.7253 12.8127 7.7253 13.0223 7.88659L20.3557 13.5276C20.4992 13.638 20.5833 13.8089 20.5833 13.99V24.5834H16.0833V18.6668C16.0833 17.8844 15.4491 17.2501 14.6667 17.2501H10.6667C9.88426 17.2501 9.25 17.8844 9.25 18.6668V24.5834H4.75V13.99C4.75 13.8089 4.83412 13.638 4.97767 13.5276L12.311 7.88659Z",
    fill: "#1A1B1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8766_290502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVillage);
export default __webpack_public_path__ + "static/media/village.78b528459f7fac12112fbf704e95fe7b.svg";
export { ForwardRef as ReactComponent };